import React from 'react';
import PropTypes from 'prop-types';

const EntityRefField = ({ record = {}, source }) => {
    var linkRef;
    var parentType = record['Type'];

    switch (parentType) {
        case 2:
            linkRef = '#/Site/' + record['id'] + '/show';
            return (
                <a href={linkRef}>
                    {record[source]}
                </a>
            );
        case 3:
            linkRef = '#/Client/' + record['id'] + '/show';
            return (
                <a href={linkRef}>
                    {record[source]}
                </a>
            );
        default:
            return (
                <span>
                    {record[source]}
                </span>
            );
    }
};

EntityRefField.propTypes = {
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default EntityRefField;


// WEBPACK FOOTER //
// ./src/components/entityRefField.js